@if(items !== null && items.length > 0)
{
  <mat-form-field appearance="fill" class="small-width">
    <mat-label>{{labelName}}</mat-label>
    <input type="text"
      placeholder="Select..."
      [title]="labelName"
      matInput
      [matAutocomplete]="auto"
      [formControl]="itemFormControl">
    <mat-autocomplete autoActiveFirstOption
        #auto="matAutocomplete"
        (optionSelected)="selectItem($event.option.value)"
        [displayWith]="displayFn">
      <mat-option *ngFor="let option of filteredItems$ | async" [value]="option">
        {{itemTemplateFn(option)}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
}
@else {
  {{noItemsMessage}}
}
